import React from 'react';
import { Box, withStyles } from '@material-ui/core';
import styles from './voice-call-settings.style';
import { useVoiceCallSettingsHook } from './useVoiceCallSettingsHook';
import { UnleashService } from '../../../../v2/services';
import IndividualLearnerSettings from './components/individual-learner-settings/individual-learner-settings';
import CommunicationSecuritySettings from './components/communication-security-settings/communication-security-settings';
import GroupScheduleSettings from './components/group-schedule-settings/group-schedule-settings';
import VideoCallsGroupScheduleSettings from './components/video-calls-group-schedule-settings/video-calls-group-schedule-settings';
import KeywordsDictionaryBanner from './components/keywords-dictionary-banner/keywords-dictionary-banner';
import KeywordsDictionary from './components/keyword-dictionary/keywords-dictionary';
import { Skeleton } from '@material-ui/lab';
import useUnleashHook from '../../../../v2/core/unleash/useUnleashHook';

const VoiceCallSettingsSkeleton = ({ classes }) => (
  <Box className={classes.root}>
    <Box className={classes.heading}>
      <Skeleton variant="text" width="40%" height={40} />
    </Box>
    <Box className={classes.content}>
      <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: '20px' }} />
      <Skeleton variant="rectangular" width="100%" height={200} style={{ marginBottom: '20px' }} />
      <Skeleton variant="rectangular" width="100%" height={200} />
    </Box>
  </Box>
);

const VoiceCallSettings = (props) => {
  const { classes } = props;

  const {
    videoCallStatus,
    voiceCallStatus,
    isLoading,
    keywordToggle,
    openKeywordsDictionary,
    closeKeywordsDictionary,
  } = useVoiceCallSettingsHook(props.locationId);
  const isVideoCallsEnabled = useUnleashHook(UnleashService.FLAGS.VIDEO_CALLS).isFlagEnabled();
  if (keywordToggle) {
    return <KeywordsDictionary closeKeywordsDictionary={closeKeywordsDictionary} locationId={props.locationId} />;
  }
  return (
    <>
      {isLoading ? (
        <VoiceCallSettingsSkeleton classes={classes} />
      ) : (
        <Box className={classes.root}>
          <Box className={classes.content}>
            <KeywordsDictionaryBanner openKeywordsDictionary={openKeywordsDictionary} />
            <CommunicationSecuritySettings locationId={props.locationId} />
            <IndividualLearnerSettings locationId={props.locationId} />
            {/* Show Voice Calls Group Schedule Settings if voice calls are enabled */}
            {voiceCallStatus && <GroupScheduleSettings locationId={props.locationId} />}
            {/* Show Video Calls Group Schedule Settings if video calls are enabled and voice calls are also enabled */}
            {isVideoCallsEnabled && videoCallStatus && <VideoCallsGroupScheduleSettings locationId={props.locationId} />}
          </Box>
        </Box>
      )}
    </>
  );
};

export default withStyles(styles)(VoiceCallSettings);
